import React from 'react';
import { useTranslation } from 'react-i18next';
import { STATS, StatWithKey } from '../../constants/data';

export const StatsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {STATS.map((stat, index) => (
            <div
              key={index}
              className="flex items-center justify-center md:justify-start gap-4 p-6 bg-slate-50 rounded-2xl border border-slate-100"
            >
              <div className="p-3 bg-white rounded-xl shadow-sm border border-slate-100">
                {stat.icon}
              </div>
              <div>
                <div className="text-3xl font-bold text-slate-900">{stat.value}</div>
                <div className="text-sm text-slate-500 font-medium">{t((stat as StatWithKey).i18nLabel)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

